import axios from "./axios";

export const getTenants = async () => {
  return await axios.get("/api/v1/provision/tenant");
};

export const getTenantInfo = async (name, meta) => {
  if(meta.action == "edit") {
    return await axios.get(`/api/v1/um/tenants/${name}/cognito/mfa`);
  } else {
    return await axios.get(`/api/v1/provision/tenant/${name}`);
  }
}

export const getTenent = async(name) => {
  return await axios.get(`/api/v1/um/tenants/${name}`);
}

export const listAdminInstances = async () => {
  return await axios.get(`/api/v1/provision/instance`);
}

export const createTenant = async (data) => {
  return await axios.put(`/api/v1/provision/tenant/${data.name}`, data);
};

export const updateTenant = async (data) => {
  return await axios.put(`/api/v1/um/tenants/${data.name}/cognito/mfa`, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const deleteTenant = async (name) => {
  return await axios.delete(`/api/v1/um/tenants/${name}`);
}

export const getSubscriptions = async (tenant) => {
  if(tenant)
    return await axios.get(`/api/v1/marketing/query?tenant=${tenant}`);
  else 
    return await axios.get(`/api/v1/marketing/query`);
};

